import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useState } from 'react';
import Search from "../../components/search";
import Nothing from "../../components/nothing";
import utils from '../../utils';
import s from './index.less';

export default function Frame (props) {
    useStyles(s);

    const Viewer = typeof document !== 'undefined' && require('react-viewer').default;
    const houseId = props.pagedata.id || '';

    const pageCode = props.pagedata.pageCode || 0;

    const opacityStyle = {
        show: { position: 'relative', opacity: 1, height: 'auto' },
        hidden: { position: 'absolute', opacity: 0, height: '0px' }
    }
    const loading = props.pagedata ? props.pagedata.loading : true;
    const houseInfo = props.pagedata.houseInfo || {};

    const [frameInfo, setFrameInfo] = useState(props.pagedata.frameInfo || {
        type: [],
        datasouse: [],
        selectIndex: 0
    });

    const [viewerImg, setViewerImg] = useState({
        modalIsOpen: false,
        selected: 0,
        list: []
    });

    const showViewer = (index, list) => {
        setViewerImg({
            modalIsOpen: true,
            selected: index,
            list
        })
    };

    const toggleModal = () => {
        setViewerImg({
            ...viewerImg,
            modalIsOpen: !viewerImg.modalIsOpen
        })
    };

    const imgError = (e) => {
        e.target.onerror = null;
        e.target.src = require("../../images/common/default-img.png");
    };

    return (
        <div className="page-frame">
            {loading ?
                <div className="page-loading">
                    <img src={require("../../images/common/loading.png")} />
                    <p>数据正在加载...</p>
                </div>
                : (pageCode === 0 ?
                    <>
                        <Search businesstype={3}
                            isdetail
                            isframe
                            housename={houseInfo.newHouseName || ''}
                            houseid={houseId} />

                        <div className="main-box">
                            <div className="base-content animation-list frame-type">
                                <div className="main">
                                    {frameInfo.type.length > 1 ?
                                        <>
                                            <ul className="type-list">
                                                {frameInfo.type.map((items, index) => {
                                                    return <li key={index} className={frameInfo.selectIndex === index ? 'active' : ''} onClick={() => setFrameInfo({ ...frameInfo, selectIndex: index })}><span>{items}</span></li>
                                                })}
                                            </ul>
                                            <ul className="data-list">
                                                {frameInfo.type.map((items, index) => {
                                                    return (<li key={index} className="animation" style={frameInfo.selectIndex === index ? opacityStyle.show : opacityStyle.hidden}>
                                                        <ul>
                                                            {frameInfo.datasouse[index] && frameInfo.datasouse[index].length > 0 && frameInfo.datasouse[index].map((item, indexs) => (
                                                                <li key={indexs}>
                                                                    <div className="img-box">
                                                                        <img onError={(e) => imgError(e)} src={item.src ? `${item.src}?x-oss-process=style/acommon` : require("../../images/common/detail-default.png")} onClick={() => showViewer(indexs, utils.imgWatermark(frameInfo.datasouse[index], 'src'))} />
                                                                        {item.isVr ?
                                                                        <div className="VR-logo">
                                                                            <img src="https://static.hsdcyf.com/hs/img/1725443792597.png" alt="" />
                                                                        </div> : null}
                                                                    </div>
                                                                    <div className="card-content">
                                                                        <div className="title ellipsis"><i className={item.saleStatus === 0 ? 'tip orange' : (item.saleStatus === 1 ? 'tip green' : 'tip grey')}>{['在售', '待售', '售罄'][item.saleStatus]}</i>{item.newModelName}</div>
                                                                        <div className="room">
                                                                            {item.rooms || item.parlor || item.bathroom || item.kitchen || item.area ?
                                                                                <div className="room">
                                                                                    {item.rooms ? `${item.rooms}室` : null}
                                                                                    {item.parlor ? `${item.parlor}厅` : null}
                                                                                    {item.bathroom ? `${item.bathroom}卫` : null}
                                                                                    {item.kitchen ? `${item.kitchen}厨` : null}
                                                                                </div> : null}
                                                                        </div>
                                                                        {item.orientation || item.area ?
                                                                        <div className="orientation">
                                                                            {item.orientation ? `${item.orientation}` : null}
                                                                            {item.area ?
                                                                                <>
                                                                                    <i className="tip" />
                                                                                    <span>{`${item.area}m²`}</span>
                                                                                </> : null}
                                                                        </div> : null}
                                                                        <div className="price-area">
                                                                            <span dangerouslySetInnerHTML={{ __html: utils.numberComparison(item.salePriceStart, item.salePriceEnd, '-', '<i>万</i>', '价格待定') }} />
                                                                            {item.salePriceRemark ?
                                                                                <div className="other-box">
                                                                                    <i className="iconfont icon-more">&#xe628;</i>
                                                                                    <i className="arrow" />
                                                                                    <div className="text-other">{item.salePriceRemark}</div>
                                                                                </div> : null}
                                                                        </div>
                                                                    </div>
                                                                    {item.isVr ? <div className="btn"><a href={item.vrUrl}>VR看房型</a></div> : null}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </li>
                                                    )
                                                })}
                                            </ul>
                                        </> : <Nothing pagetype="detail" />}
                                </div>
                            </div>

                            <div className="detail-title-price-box">
                                <div className="header-title">
                                    <h1>{houseInfo.newHouseName}</h1>
                                    <p>
                                        {houseInfo.statusF ? <span className="sale">{houseInfo.statusF}</span> : null}
                                        {houseInfo.housekeeperTypeF ? <span>{houseInfo.housekeeperTypeF}</span> : null}
                                    </p>
                                </div>
                                <div className="header-price">
                                    <span className="name">参考均价</span>
                                    <span className="total">{houseInfo.salePrice || '价格待定'}</span>
                                    {houseInfo.salePrice ? <span className="unit">元/平（单价）</span> : null}
                                </div>
                            </div>
                        </div>
                    </> : <Nothing pagetype={pageCode} />)}

            { Viewer ? <Viewer
                className="react-img"
                visible={viewerImg.modalIsOpen}
                onClose={toggleModal}
                activeIndex={viewerImg.selected}
                images={viewerImg.list}
                disableMouseZoom
                drag={false}
            /> : null}
        </div>
    );
}